import './ApplyNow.css';

export default function ApplyNow({ label, className, icon = '', onClick, disabled = false }) {
    return (
        <button
            className={`apply-now-button ${className}`}
            type={onClick ? 'button' : 'submit'}
            {...(onClick && { onClick: onClick })}
            disabled={disabled}
        >
            {label}
            {
                icon && <img className='end-icon' src={icon} alt='label' />
            }
        </button >
    )
}